import React from 'react';
import '../../App.css';
import MainSection from '../MainSection';
import Cards from '../Cards';

function Home () {
return (
    <>
    <MainSection />
    <Cards />
    </>
    )
}

export default Home;